module.exports = __webpack_public_path__ + "42cd0e5a11754002eb4ce38132eb6f6d.jpg";